import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpService } from '../service/http.service';
import { UserService } from '../service/user.service';
import { Vademecum } from '../vademecum';
import { LoginService } from '../security/login.service';

@Component({
  selector: 'app-vademecum-detail',
  templateUrl: './vademecum-detail.component.html',
  styleUrls: ['./vademecum-detail.component.css']
})
export class VademecumDetailComponent implements OnInit {

  bookingId: any;
  vademecum: Vademecum | null = null;

  constructor(
    private route: ActivatedRoute,
    private httpService: HttpService,
    private loginService: LoginService
  ) {
    this.loginService.activatedNavigationComponent = false;
   }

  ngOnInit() {
    this.bookingId = this.route.snapshot.paramMap.get("bookingId");
    this.httpService.getVademecumByBookingId(this.bookingId)
    .subscribe(vademecum => this.vademecum = vademecum);
  }

}
